"use strict";
'use es6';
/**
 * @deprecated
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SERVICE_ENTERPRISE = exports.SERVICE_PROFESSIONAL = exports.SERVICE_STARTER = exports.SERVICE_FREE = exports.SALES_ENTERPRISE = exports.SALES_PROFESSIONAL = exports.SALES_STARTER = exports.SALES_FREE = exports.MARKETING_ENTERPRISE = exports.MARKETING_PROFESSIONAL = exports.MARKETING_STARTER = exports.MARKETING_FREE = exports.CMS_ENTERPRISE = exports.CMS_STANDALONE = exports.HUBSPOT_FREE = exports.CRM_FREE = void 0;
var CRM_FREE = 'CRM_FREE';
exports.CRM_FREE = CRM_FREE;
var HUBSPOT_FREE = 'HUBSPOT_FREE';
exports.HUBSPOT_FREE = HUBSPOT_FREE;
var CMS_STANDALONE = 'CMS_STANDALONE';
exports.CMS_STANDALONE = CMS_STANDALONE;
var CMS_ENTERPRISE = 'CMS_ENTERPRISE';
exports.CMS_ENTERPRISE = CMS_ENTERPRISE;
var MARKETING_FREE = 'MARKETING_FREE';
exports.MARKETING_FREE = MARKETING_FREE;
var MARKETING_STARTER = 'MARKETING_STARTER';
exports.MARKETING_STARTER = MARKETING_STARTER;
var MARKETING_PROFESSIONAL = 'MARKETING_PROFESSIONAL';
exports.MARKETING_PROFESSIONAL = MARKETING_PROFESSIONAL;
var MARKETING_ENTERPRISE = 'MARKETING_ENTERPRISE';
exports.MARKETING_ENTERPRISE = MARKETING_ENTERPRISE;
var SALES_FREE = 'SALES_FREE';
exports.SALES_FREE = SALES_FREE;
var SALES_STARTER = 'SALES_STARTER';
exports.SALES_STARTER = SALES_STARTER;
var SALES_PROFESSIONAL = 'SALES_PROFESSIONAL';
exports.SALES_PROFESSIONAL = SALES_PROFESSIONAL;
var SALES_ENTERPRISE = 'SALES_ENTERPRISE';
exports.SALES_ENTERPRISE = SALES_ENTERPRISE;
var SERVICE_FREE = 'SERVICE_FREE';
exports.SERVICE_FREE = SERVICE_FREE;
var SERVICE_STARTER = 'SERVICE_STARTER';
exports.SERVICE_STARTER = SERVICE_STARTER;
var SERVICE_PROFESSIONAL = 'SERVICE_PROFESSIONAL';
exports.SERVICE_PROFESSIONAL = SERVICE_PROFESSIONAL;
var SERVICE_ENTERPRISE = 'SERVICE_ENTERPRISE';
exports.SERVICE_ENTERPRISE = SERVICE_ENTERPRISE;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/Tier.js
// module id = 178
// module chunks = 209 210 211 212 213